import throttle from "../utils/throttle";

const enterAnimationTrigger = [
    '.frame', // default typo3 element
    '.quote',
    '.intro-text',
    '.accordion-group',
    '.fact-area',
    '.fullwidth-image',
    '.gallery2',
    '.gallery-50-50',
    '.link-list',
    '.newsletter-sign-up',
    '.project-intro',
    '.image-carousel',
].join(',');

function isInViewport(rect) {
    return rect.top < window.innerHeight;
}

function onScroll() {
    $(enterAnimationTrigger)
        .not('.js-entered')
        .each(function () {
            const $self = $(this), self = this;

            if (isInViewport(self.getBoundingClientRect())) {
                $self.addClass('is-entering');
                $self.addClass('js-entered');
                $self.removeClass('is-out');

                $self.on('transitionend', () => {
                    $self.removeClass('is-entering');
                });
            }
        });
}

window.addEventListener('scroll', throttle(onScroll, 100), {passive: true});

// Add entering class to all elements already visible in viewport
$(enterAnimationTrigger).each(function () {
    const self = this, $self = $(self);
    $self.addClass('is-out');
    setTimeout(() => onScroll());
});
